import { SET_TAGS, ADD_TAGS, DELETE_TAG } from "./types";

const state = {
  tags: [],
};

const mutations = {
  [SET_TAGS](state, tags) {
    state.tags = tags;
  },
  [ADD_TAGS](state, tag) {
    if (tag) {
      state.tags.push(tag);
    }
  },
  [DELETE_TAG](state, tagId) {
    const index = state.tags.findIndex(tag => tag.id == tagId);

    if (index > -1) {
      state.tags.splice(index, 1);
    }
  }
};

import * as getters from "./getters";
import * as actions from "./actions";

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
